import { useMemo } from 'react';
import { FieldData } from 'create/bulk/common/types';
import { DropdownState } from '../types';

/**
 * Hook that gives the hybrid list from a given field
 */

export const useHybrids = ({
  fields,
  fieldId,
  hybrid1,
  hybrid2
}: {
  fields: FieldData[];
  fieldId: string;
  hybrid1?: DropdownState;
  hybrid2?: DropdownState;
}) => {
  const hybrids = useMemo(() => {
    return fields
    .filter((f) => f.id === fieldId)
    .map((f) => ({
      name: f.hybrid.name,
      id: f.hybrid.id
    }));
  }, [fields, fieldId]);

  const isUniqueHybrid = useMemo(() => hybrids.length === 1, [hybrids]);

  const hybridsList = useMemo(() =>
    hybrids.filter((hybrid: DropdownState) => hybrid.id !== hybrid1?.id && hybrid.id !== hybrid2?.id),
  [hybrids, hybrid1, hybrid2]);

  return { hybrids, isUniqueHybrid, hybridsList };
};